/** 
* @name: ui-tag 
* @Description: 用于标记 
* size：tag大小(内置large、medium、mini三种) 
* width：tag宽(String类型，需加上单位) 
* height：tag高(String类型，需加上单位) 
* fontSize：tag字体大小(String类型，需加上单位) 
* bgColor：tag背景色(String类型) 
* color：tag字体颜色(String类型) 
* @Author: liulinmei 
* @Date: 2021-12-8 12:28:46
*/
<template>
  <div
    class="ui-tag"
    :style="defaultStyle"
  >
    <slot>即报即采</slot>
  </div>
</template>

<script>
export default {
  name: 'ui-tag',
  props: {
    size: {
      type: String,
      default: 'medium',
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    lineHeight:{
      type: String,
    },
    fontSize: {
      type: String,
    },
    bgColor: {
      type: String,
    },
    color: {
      type: String,
    },
  },
  computed: {
    defaultStyle: function () {
      let styleArr = {
        large: {
          width: this.width || '40px',
          height: this.height || '40px',
          lineHeight:this.lineHeight || '20px',
          // lineHeight: this.height || '40px',
          fontSize: this.fontSize || '14px',
          background: this.bgColor || 'rgba(189, 157, 95, 0.3)',
          color: this.color || '#BD9D5F',
        },
        medium: {
          width: this.width || '60px',
          height: this.height || '24px',
          lineHeight: this.height || '24px',
          fontSize: this.fontSize || '12px',
          background:
            this.bgColor || 'linear-gradient(90deg, #2161EA 0%, #36BEF9 100%)',
          color: this.color || '#FFFFFF',
        },
        mini: {
          width: this.width || '36px',
          height: this.height || '20px',
          lineHeight: this.height || '20px',
          fontSize: this.fontSize || '12px',
          background:
            this.bgColor ||
            'linear-gradient(360deg, #FF6600 0%, #FF6600 1%, #FF944C 100%)',
          color: this.color || '#FFFFFF',
        },
      }
      return styleArr[this.size]
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-tag {
  display: inline-block;
  vertical-align: middle;
  padding: 0 6px;
  box-sizing: border-box;
  text-align: center;
}
.ui-tag + .ui-tag {
  margin-left: 10px;
}
</style>
